import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "field" }, "Reference", -1)
const _hoisted_2 = { class: "value" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "field" }, "Cost Center", -1)
const _hoisted_4 = { class: "value" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "field" }, "Priority", -1)
const _hoisted_6 = { class: "value" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "field" }, "Title", -1)
const _hoisted_8 = { class: "value" }
const _hoisted_9 = {
  key: 0,
  class: "item-info"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "field" }, "Created", -1)
const _hoisted_11 = { class: "value" }
const _hoisted_12 = {
  key: 0,
  class: "field"
}
const _hoisted_13 = {
  key: 1,
  class: "value"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "field" }, "Description", -1)
const _hoisted_15 = { class: "value" }
const _hoisted_16 = {
  key: 0,
  class: "item-info"
}
const _hoisted_17 = {
  key: 2,
  class: "field"
}
const _hoisted_18 = {
  key: 3,
  class: "value"
}
const _hoisted_19 = /*#__PURE__*/_createTextVNode("Edit Task")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_StringLinkList = _resolveComponent("StringLinkList")!
  const _component_StringLinkInfo = _resolveComponent("StringLinkInfo")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, "@" + _toDisplayString(_ctx.item.refid), 1),
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, "@" + _toDisplayString(_ctx.item.ccid), 1),
    _hoisted_5,
    _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.priorityDescription), 1),
    _hoisted_7,
    _createElementVNode("div", _hoisted_8, [
      _createVNode(_component_StringLinkList, {
        list: _ctx.processLine(_ctx.item.title),
        highlight: _ctx.highlight,
        onLinkClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.doSubItemClick($event, -1)))
      }, null, 8, ["list", "highlight"]),
      (_ctx.currentInfo && _ctx.currentIdx === -1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createElementVNode("div", {
              class: "close-button",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.currentInfo = null))
            }, "x"),
            _createVNode(_component_StringLinkInfo, {
              str: _ctx.currentInfo,
              highlight: [],
              onItemClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.doSubItemClick($event, _ctx.idx)))
            }, null, 8, ["str"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _hoisted_10,
    _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.dtTmFormat(_ctx.item.created)) + " — " + _toDisplayString(_ctx.timeAgo(_ctx.item.created)), 1),
    (_ctx.item.updated)
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, "Edited"))
      : _createCommentVNode("", true),
    (_ctx.item.updated)
      ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(_ctx.dtTmFormat(_ctx.item.updated)) + " — " + _toDisplayString(_ctx.timeAgo(_ctx.item.updated)), 1))
      : _createCommentVNode("", true),
    _hoisted_14,
    _createElementVNode("div", _hoisted_15, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.split(_ctx.item.description), (line, idx) => {
        return (_openBlock(), _createElementBlock("div", {
          key: idx,
          class: "list-line"
        }, [
          _createElementVNode("div", null, [
            _createVNode(_component_StringLinkList, {
              list: _ctx.processLine(line),
              highlight: _ctx.highlight,
              onLinkClick: ($event: any) => (_ctx.doSubItemClick($event, idx))
            }, null, 8, ["list", "highlight", "onLinkClick"])
          ]),
          (_ctx.currentInfo && _ctx.currentIdx === idx)
            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                _createElementVNode("div", {
                  class: "close-button",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.currentInfo = null))
                }, "x"),
                _createVNode(_component_StringLinkInfo, {
                  str: _ctx.currentInfo,
                  highlight: [],
                  onItemClick: ($event: any) => (_ctx.doSubItemClick($event, idx))
                }, null, 8, ["str", "onItemClick"])
              ]))
            : _createCommentVNode("", true)
        ]))
      }), 128))
    ]),
    (_ctx.showEdit)
      ? (_openBlock(), _createElementBlock("div", _hoisted_17, "Edit"))
      : _createCommentVNode("", true),
    (_ctx.showEdit)
      ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
          _createVNode(_component_router_link, {
            to: `/cc/${_ctx.item.ccid}/task/${_ctx.item.dbid}`
          }, {
            default: _withCtx(() => [
              _hoisted_19
            ]),
            _: 1
          }, 8, ["to"])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}